import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import ThemeContext from '../../utils/theming';

const Button = styled.button`
    flex: 1;
    height: ${props => (props.isLongText ? `65px` : `88px`)};
    max-height: 100px;
    border-radius: 4px;
    border: solid 1px #f1f1ee;
    text-transform: uppercase;
    margin: 0 9px;
    cursor: pointer;
    background-color: #fff;
    position: relative;
    padding-left: 10px;
    padding-right: 10px;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 1);

    &:focus {
        outline: none;
    }

    &:hover {
        background-color: ${({ theme }) => theme.colors.primary};
        border: solid 1px ${({ theme }) => theme.colors.primary};
        color: #fff;
        span {
            color: #fff;
        }
    }

    @media (max-width: 30em) {
        margin: 0 0 12px;
    }

    &.clicked {
        @media (max-width: 30em) {
            background-color: ${({ theme }) => theme.colors.primary};
            border: solid 1px ${({ theme }) => theme.colors.primary};
            color: #fff;

            span {
                color: #fff;
            }
        }
    }
`;

const Text = styled.span`
    font-family: Averta;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 2px;
    text-align: center;
    color: #333;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    position: absolute;
    left: 0;
    width: 100%;
    line-height: 100%;
`;

const LocalRepAction = props => (
    <Button
        isLongText={props.isLongText}
        onClick={props.onClick}
        data-action={props.action.identifier}
        theme={useContext(ThemeContext)}
    >
        <Text>{props.action.label}</Text>
    </Button>
);

LocalRepAction.propTypes = {
    action: PropTypes.object.isRequired,
    isLongText: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string
};

export default LocalRepAction;
